import React, {memo} from 'react';
import {Button, InstagramIcon} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import PrivacyPolicyButton, {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const Instagram = ({
  pending,
  privacyPolicyUrl,
  onClick,
}: {
  pending: boolean;
  onClick: (event: React.MouseEvent) => void;
} & PrivacyPolicyButtonProps) => {
  const {t} = useTranslation(['assetservices']);

  return (
    <>
      <Button
        onClick={onClick}
        label={!pending ? t('str_ButtonConnectToInstagram') : t('*:str_TitlePleaseWait')}
        buttonStyle={'distinct'}
        startIcon={<InstagramIcon />}
        disabled={pending}
      />
      <PrivacyPolicyButton privacyPolicyUrl={privacyPolicyUrl} />
    </>
  );
};

export default memo(Instagram);
